// src/components/ThongTinHTDTComponent.jsx
import React, { useEffect, useState } from 'react';
import { Accordion, Container, Row, Col, Spinner, Table, Form, InputGroup } from 'react-bootstrap';
import ManagerService from '../../services/ManagerService';

const ThongTinHTDTComponent = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]); // Dữ liệu sau khi lọc
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState(''); // Từ khóa tìm kiếm

    // Gọi API khi component được mount
    useEffect(() => {
        ManagerService.getHTDTData()
            .then((response) => {
                setData(response.data);
                setFilteredData(response.data); // Khởi tạo dữ liệu đã lọc
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setLoading(false);
            });
    }, []);

    // Hàm xử lý khi thay đổi từ khóa tìm kiếm
    const handleSearch = (event) => {
        const term = event.target.value.toLowerCase();
        setSearchTerm(term);

        // Lọc dữ liệu dựa trên từ khóa tìm kiếm
        const filtered = data.filter(
            (item) =>
                item.ten_tuyen.toLowerCase().includes(term) || // Lọc theo tên tuyến
                item.bien_kiem_soat.toLowerCase().includes(term) // Lọc theo biển kiểm soát
        );
        setFilteredData(filtered);
    };

    if (loading) {
        return (
            <Container className="text-center mt-5">
                <Spinner animation="border" />
                <p>Đang tải dữ liệu...</p>
            </Container>
        );
    }

    return (
        <Container className="mt-5">
            <h1 className="text-center mb-4">Thông Tin HTĐT</h1>

            {/* Thanh tìm kiếm */}
            <InputGroup className="mb-3">
                <Form.Control
                    placeholder="Tìm kiếm theo tên tuyến hoặc biển kiểm soát..."
                    value={searchTerm}
                    onChange={handleSearch}
                />
            </InputGroup>

            <Accordion>
                {filteredData.map((item) => (
                    <Accordion.Item key={item.id} eventKey={item.id.toString()}>
                        <Accordion.Header>{item.ten_tuyen}</Accordion.Header>
                        <Accordion.Body>
                            <Row>
                                <Col md={6}>
                                    <p><strong>Biển kiểm soát:</strong> {item.bien_kiem_soat}</p>
                                    <p><strong>Km đi:</strong> {item.km_di}</p>
                                    <p><strong>Khu vực:</strong> {item.khu_vuc}</p>
                                </Col>
                                <Col md={6}>
                                    <p><strong>Trọng tải:</strong> {item.trong_tai}</p>
                                    <p><strong>Km về:</strong> {item.km_ve}</p>
                                    <p><strong>Thời gian áp dụng:</strong> {item.thoi_gian_ap_dung}</p>
                                </Col>
                            </Row>
                            <h3 className="mt-5">Thông Tin Chặng</h3>
                            <Table striped bordered hover className="mt-3 custom-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: '5%' }}>#</th>
                                        <th style={{ width: '18%' }}>Điểm Đi</th>
                                        <th style={{ width: '18%' }}>Điểm Đến</th>
                                        <th style={{ width: '14%' }}>Thời Gian Bắt Đầu</th>
                                        <th style={{ width: '14%' }}>Thời Gian Kết Thúc</th>
                                        <th style={{ width: '9%' }}>Km Đầu</th>
                                        <th style={{ width: '9%' }}>Km Cuối</th>
                                        <th style={{ width: '7%' }}>Chiều</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {item.changs.map((chang, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{chang.diem_di}</td>
                                            <td>{chang.diem_den}</td>
                                            <td>{chang.thoi_gian_bat_dau || 'N/A'}</td>
                                            <td>{chang.thoi_gian_ket_thuc || 'N/A'}</td>
                                            <td>{chang.km_dau}</td>
                                            <td>{chang.km_cuoi}</td>
                                            <td>{chang.chieu}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </Accordion>
        </Container>
    );
};

export default ThongTinHTDTComponent;
